/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {LitElement, html, CSSResultArray, TemplateResult} from 'lit';
import { customElement, property} from 'lit/decorators.js';
import {styles} from './nile-side-bar-panel.css';
import NileElement from '../internal/nile-element';


/**
 * Nile side-bar-panel component.
 *
 * @tag nile-side-bar-panel
 *
 */
@customElement('nile-side-bar-panel')
export class NileSideBarPanel extends NileElement {

	/**
	 * The styles for nile-side-bar-panel
	 * @remarks If you are extending this class you can extend the base styles with super. Eg `return [super(), myCustomStyles]`
	 */
	public static get styles(): CSSResultArray {
		return [styles];
	}

	/* #endregion */

	/* #region Methods */

	/**
	 * Render method
	 * @slot This is a slot test
	 */
	public render(): TemplateResult {
		return html`
			<slot> </slot>
			`;
	}

	/* #endregion */
}

export default NileSideBarPanel;

declare global {
  interface HTMLElementTagNameMap {
    'nile-side-bar-panel': NileSideBarPanel;
  }
}